<template>
    <div>
        <div style="margin-top:50px;margin-left:50px;margin-right:50px;">
            <el-table
            :data="request_info"
            style="width:100%"
            stripe
            border>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="title" label="痛点名称" min-width="55%"></el-table-column>
                <el-table-column prop="review_time" label="修改时间" min-width="12%"></el-table-column>
                <el-table-column prop="expert_name" label="专家" min-width="10%"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="8%"></el-table-column>
                <el-table-column prop="operations" label="操作" min-width="15%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="color:#409EFF;font-weight:bold;"
                        @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button
                        type="text"
                        style="color:#67C23A;font-weight:bold;"
                        :disabled="scope.row.status=='已发布' || scope.row.status=='已拒绝'"
                        @click="handleAccept(scope.row.id)">接受</el-button>
                        <el-button
                        type="text"
                        style="color:#F56C6C;font-weight:bold;"
                        :disabled="scope.row.status=='已发布' || scope.row.status=='已拒绝'"
                        @click="handleReject(scope.row.id)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
            title="填写拒绝理由"
            :visible.sync="dialogVisible_reject"
            width="30%"
            class="rejuect_reason_dialog">
                <el-input v-model="reject_reason" type="textarea" :rows="3"></el-input>
                <div style="margin-top:15px;">
                    <el-button type="primary" size="mini" @click="rejuectApprove">提交</el-button>
                    <el-button type="primary" size="mini" @click="cancel_reject">取消</el-button>
                </div>
            </el-dialog>
            <div style="margin-top:10px;" v-if="request_info.length > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageinfo.current"
                    :page-sizes="pageinfo.page_sizes"
                    :page-size="pageinfo.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="pageinfo.count">
                </el-pagination>
            </div>
            <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog"
            @opened="handleDialogOpened"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <template #title>
                <div class="dialog-header">
                <span>{{ dialog_title }}</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <div class="dialog-content">
                <div>
                    <div style="float:left;margin-left:50px;">
                        <el-button size="mini" icon="el-icon-document-checked" type="primary" @click="saveRichText" :disabled="this.current_status=='已发布' || this.current_status=='已拒绝'">保存</el-button>
                        <el-button size="mini" icon="el-icon-edit" type="primary" @click="editRichText" :disabled="this.current_status=='已发布' || this.current_status=='已拒绝'">编辑</el-button>
                    </div>
                    <div style="margin-right:50px;text-align:left;float:right;">
                        <span style="color:#303133;">显示修改前内容</span>
                        <el-switch
                        v-model="show_ori_content"
                        @change="switch_content"
                        style="margin-left:10px;">
                        </el-switch>
                    </div>
                </div>
                <div style="margin-left:50px;margin-right:50px;padding-top:20px;clear:both;">
                    <!-- 此处获取专家修改前后的痛点内容 -->
                    <div style="width:49.5%;float:left;" v-show="show_ori_content">
                        <span style="font-weight:bold;font-size:15px;">修改前内容</span>
                        <div class="ql-editor" v-html="content_ori" style="margin-top:15px;"></div>
                    </div>
                    <div style="float:right;" :style="dynamicStyle">
                        <span style="font-weight:bold;font-size:15px;">修改后内容</span>
                        <div class="editor-container" v-show="isEdit">
                            <quill-editor
                            v-model="content_expert"
                            ref="myQuillEditor"
                            :options="editorOptions"
                            style="margin-top:15px;"
                            />
                        </div>
                        <div class="ql-editor" v-html="content_expert" style="margin-top:15px;" v-show="!isEdit"></div>
                    </div>
                    <!-- <el-button type="primary" @click="savePainSpotConfig" v-if="dialog_title=='配置痛点'" style="margin-top:30px;margin-left:50px;">保存</el-button> -->
                </div>
            </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    components: { quillEditor },
    created() {
        this.getAmendmentReviewInfos();
    },
    data() {
        return {
            dialog_title: '',
            dialogVisible: false,
            // search_name: '',
            // search_role: '',
            request_info: [],
            // request_info: [
            //     {'title': '关键人才流失率高怎么办？', 'review_time': '2025-05-13', 'expert_name': '付寅', 'status': '已发布'},
            //     {'title': '关键人才流失率高怎么办？', 'review_time': '2025-05-12', 'expert_name': '付寅', 'status': '已拒绝'},
            //     {'title': '关键人才流失率高怎么办？', 'review_time': '2025-05-11', 'expert_name': '付寅', 'status': '待处理'}],
            // details_info: [
            //     {'id': 1, 'title': '痛点1', 'datetime': '2025-03-14'}, 
            //     {'id': 3, 'title': '痛点2', 'datetime': '2025-04-12'},
            //     {'id': 5, 'title': '痛点3', 'datetime': '2025-02-11'},
            //     {'id': 7, 'title': '痛点4', 'datetime': '2025-05-24'},
            //     {'id': 9, 'title': '痛点5', 'datetime': '2025-05-05'}],
            // details_columns: [],
            // selectedRows: [],
            content_ori: '',
            content_expert: '',
            isEdit: false,
            editorOptions: {
                modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['link'],
                    ['clean']
                ]
                },
                placeholder: '请输入内容...',
                theme: 'snow',
            },
            show_ori_content: true,
            width: '50%',
            border_left: '1px solid #ebeef5',
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 20,
                page_sizes: [1, 10, 20, 50, 100],
            },
            editor: null,
            toolbar: null,
            reject_reason: '',
            reject_id: null,
            dialogVisible_reject: false,
            current_pid: null,
            current_status: '',
        }
    },
    computed: {
        dynamicStyle() {
            return {
                width: this.width,
                'border-left': this.border_left,
            }
        }
    },
    methods: {
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            this.getAmendmentReviewInfos();
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            this.getAmendmentReviewInfos();
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleDialogOpened() {
            this.$nextTick(() => {
                // 新增粘贴事件监听
                const quill = this.$refs.myQuillEditor.quill;
                this.editor = quill.root;
                this.toolbar = quill.getModule('toolbar');
                this.editor.removeEventListener('paste', this.handlePasteImage);
                this.editor.addEventListener('paste', this.handlePasteImage);
                // 上传文件的监听
                this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
            })
        },
        getAmendmentReviewInfos() {
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
            }
            getdata.getListP("getAmendmentReviewInfos", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.request_info = resp.data.data;
                    this.pageinfo.count = resp.data.count;          
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        switch_content(val) {
            if(val){
                this.width = '50%';
                this.border_left = '1px solid #ebeef5';
                this.show_ori_content = true;
            }else{
                this.width = '100%';
                this.border_left = '0px';
                this.show_ori_content = false;
            }
        },
        handleAccept(rid) {
            let params;
            params = {
                id: rid,
            }
            getdata.getListP("acceptAmendmentReview", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.getAmendmentReviewInfos();         
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleReject(rid) {
            this.reject_reason = '';
            this.reject_id = rid;
            this.dialogVisible_reject = true;
        },
        rejuectApprove() {
            let params;
            params = {
                id: this.reject_id,
                reject_reason: this.reject_reason
            }
            getdata.getListP("rejectAmendmentReview", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.dialogVisible_reject = false;
                    this.getAmendmentReviewInfos();         
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        cancel_reject() {
            this.dialogVisible_reject = false;
        },
        handleEdit(row) {
            this.dialog_title = '编辑痛点';
            this.current_pid = row.id;
            this.current_status = row.status;
            // this.dialogVisible = true;
            this.getAmendmentReviewContens(row.id);
        },
        getAmendmentReviewContens(rid) {
            let params;
            params = {
                id: rid,
            }
            
            getdata.getListP("getAmendmentReviewContens", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.content_ori = resp.data.content_ori;
                    this.content_expert = resp.data.content_expert;
                    this.dialogVisible = true;                  
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        editRichText() {
            this.isEdit = true;
        },
        saveRichText() {
            postdata.postList("acceptAmendmentReviewWithMod", JSON.stringify({'id': this.current_pid, 'mod_content': this.content_expert}))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.isEdit = false;
                    this.dialogVisible = false;
                    this.getAmendmentReviewInfos();      
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 图片上传处理
        imageHandler() {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.click()
            
            input.onchange = async () => {
                const file = input.files[0]
                const formData = new FormData()
                formData.append('image', file)

                // 调用后端上传接口
                const { data } = await postdata.uploadFiles('uploadImages', formData)
                const quill = this.$refs.myQuillEditor.quill
                const range = quill.getSelection()
                quill.insertEmbed(range.index, 'image', data.url)
            }
            },
            // 新增粘贴图片处理方法
            async handlePasteImage(event) {
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            let blob = null;

            for (const item of items) {
                if (item.type.indexOf('image') === 0) {
                blob = item.getAsFile();
                break;
                }
            }

            if (blob) {
                event.preventDefault();
                const formData = new FormData();
                formData.append('image', blob);
                
                try {
                const { data } = await postdata.uploadFiles('uploadImages', formData, {
                    headers: {
                    'Content-Type': 'multipart/form-data'
                    }
                });
                
                const quill = this.$refs.myQuillEditor.quill;
                const range = quill.getSelection();
                quill.insertEmbed(range.index, 'image', data.url);
                } catch (error) {
                console.error('图片上传失败:', error);
                }
            }
        },
    },
    mounted() {
        // 新增粘贴事件监听
        const editor = this.$refs.myQuillEditor.quill.root;
        editor.addEventListener('paste', this.handlePasteImage);
        // 销毁时移除监听
        this.$once('hook:beforeDestroy', () => {
        editor.removeEventListener('paste', this.handlePasteImage);
        });
        // 上传文件的监听
        this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
    },
}
</script>

<style scoped>
/* ::v-deep .el-input__inner {
    height: 28px;
    line-height: 28px;
}
::v-deep .el-select .el-input .el-select__caret {
    line-height: 28px;
} */
::v-deep .el-table th {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-table__row td {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
/* 【重要！】ql-editor 自带overflow，通过调整这里的height去自适应页面高度 */
.ql-editor {
  height: calc(100vh - 80px - 270px) !important;
}
::v-deep .editor-container .ql-editor {
  height: calc(100vh - 80px - 336px) !important;
}
.rejuect_reason_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.el-button--text.is-disabled {
  color: #c0c4cc !important;
}
</style>

